/**
 * This will watch a element for viewport intersection
 * @example ng-intersects="observer.footer.navigation"
 */

const ngIntersects = ['$rootScope', ($rootScope) => {
    return {
        scope: { model: '=ngIntersects'},
        link: ( $scope, $item, $params ) => {
            $scope.model = false;
            if (!("IntersectionObserver" in window)) {
                $scope.model = true;
                $scope.$apply();
                return false;
            }
            let intersect = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (entry.intersectionRatio > 0) {
                        intersect.unobserve(entry.target);
                        $scope.model = true;
                        $scope.$apply();
                    }
                });
            });
            intersect.observe($item[0]);
        }
    }
}];

export default ngIntersects;

